// import React from 'react';
// import { FormattedMessage } from 'react-intl';
// import globalMessages from 'containers/App/messages';

const validate = values => {
  const errors = {};
  return errors;
};

export default validate;